"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NextArrow = exports.PrevArrow = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _reactResponsive = require("react-responsive");

var _Icon = _interopRequireDefault(require("../../../Icon"));

var _Elements = require("../../Elements");

var _Elements2 = require("./Elements");

var _constants = require("../../constants/constants");

var PrevArrow = function PrevArrow(_ref) {
  var onClick = _ref.onClick,
      transparentBg = _ref.transparentBg,
      colour = _ref.colour,
      offset = _ref.offset;
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  return /*#__PURE__*/_react["default"].createElement(_Elements2.ArrowWrapperBox, {
    flex: true,
    align: "center",
    onClick: onClick,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    offset: offset
  }, /*#__PURE__*/_react["default"].createElement(_Elements2.ArrowBox, {
    flex: true,
    align: "center",
    justify: "center",
    transparentBg: transparentBg
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronLeft",
    size: isMobileLandScape ? 'sm' : 'xs'
  })));
};

exports.PrevArrow = PrevArrow;
PrevArrow.defaultProps = {
  onClick: function onClick() {},
  transparentBg: true,
  colour: '',
  offset: 0
};
PrevArrow.propTypes = {
  onClick: _propTypes["default"].func,
  transparentBg: _propTypes["default"].bool,
  colour: _propTypes["default"].string,
  offset: _propTypes["default"].number
};

var NextArrow = function NextArrow(_ref2) {
  var withText = _ref2.withText,
      text = _ref2.text,
      onClick = _ref2.onClick,
      transparentBg = _ref2.transparentBg,
      colour = _ref2.colour,
      offset = _ref2.offset;
  var isMobileLandScape = (0, _reactResponsive.useMediaQuery)({
    query: '(min-width: 667px)'
  });
  return /*#__PURE__*/_react["default"].createElement(_Elements2.ArrowWrapperBox, {
    flex: true,
    align: "center",
    direction: "right",
    onClick: onClick,
    colour: _constants.PORTFOLIO_THEME_COLOR[colour],
    offset: offset
  }, withText && /*#__PURE__*/_react["default"].createElement(_Elements.PortfolioParagraph, {
    portfolioForeground1: true,
    mr: "sm"
  }, /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: text
  })), /*#__PURE__*/_react["default"].createElement(_Elements2.ArrowBox, {
    flex: true,
    align: "center",
    justify: "center",
    transparentBg: transparentBg
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    svg: "chevronRight",
    size: isMobileLandScape ? 'sm' : 'xs'
  })));
};

exports.NextArrow = NextArrow;
NextArrow.defaultProps = {
  withText: false,
  text: 'portfolio.theme.gallery.next_gallery',
  onClick: function onClick() {},
  transparentBg: true,
  colour: '',
  offset: 0
};
NextArrow.propTypes = {
  withText: _propTypes["default"].bool,
  text: _propTypes["default"].string,
  onClick: _propTypes["default"].func,
  transparentBg: _propTypes["default"].bool,
  colour: _propTypes["default"].string,
  offset: _propTypes["default"].number
};